"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenImage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const download_helper_1 = require("@front/helpers/download.helper");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="gen-image-container">
    <div class="gen-image-content" ?hidden="${x => x.loading || x.error}">
        ${(0, fast_element_1.when)(x => { var _a, _b; return ((_b = (_a = x.image) === null || _a === void 0 ? void 0 : _a.generation_params) === null || _b === void 0 ? void 0 : _b.prompt) && !x.tmp; }, (0, fast_element_1.html) `<div class="image-prompt">${x => { var _a, _b; return (_b = (_a = x.image) === null || _a === void 0 ? void 0 : _a.generation_params) === null || _b === void 0 ? void 0 : _b.prompt; }}</div>`)}
        <img 
            src="${x => x.tmp ? `data:image/${x.imageFormat};base64,${x.slotContent}` : x.getFilePath()}" 
            alt="${x => { var _a, _b; return (_b = (_a = x.image) === null || _a === void 0 ? void 0 : _a.generation_params) === null || _b === void 0 ? void 0 : _b.prompt; }}"           
            class="generated-image"
        />
        ${(0, fast_element_1.when)(x => !x.tmp, (0, fast_element_1.html) `<div class="image-actions">
            <button 
                class="btn btn-secondary" 
                @click="${x => x.handleDownload()}"
                title="${'gen-image.download'.t()}"
            >
                <i class="simple-icon-cloud-download mr-1"></i>                
            </button>
            <button 
                class="btn btn-secondary" 
                @click="${x => x.handleCopyToClipboard()}"
                title="${'gen-image.copyToClipboard'.t()}"
            >
                <i class="simple-icon-docs mr-1"></i>                
                <i class="simple-icon-check" ?hidden="${x => !x.isCopied}"></i>   
            </button>
        </div>`)}
    </div>

    <div class="loading-state" ?hidden="${x => !x.loading}">
        <div class="spinner"></div>
        <span class="loading-text">${'gen-image.loading'.t()}</span>
    </div>

    <div class="error-state" ?hidden="${x => !x.error}">
        <div class="error-icon">⚠️</div>
        <span class="error-text">${x => x.error}</span>
    </div>

    <div style="display: none;">
        <slot></slot>
    </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: inline-block;
  max-width: 100%;
  width: auto;
  margin: 1rem 0;
}

.gen-image-container {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--primary-color);
  background-color: var(--chat_header_color);
  box-shadow: 5px 5px 4px rgba(0, 0, 0, 0.3);
  padding: 10px;
}

.gen-image-content {
  position: relative;
}
.gen-image-content:hover .image-actions {
  opacity: 1;
  transform: translateY(0);
}
.gen-image-content:hover .image-prompt {
  opacity: 0.9;
  transform: translateY(0);
}

.generated-image {
  width: 100%;
  height: auto;
  display: block;
  max-width: 100%;
  background: var(--neutral-layer-2);
}

.image-prompt {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), transparent);
  color: white;
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.4;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.2s ease-in-out;
  backdrop-filter: blur(10px);
  z-index: 1;
  max-height: 50%;
  overflow-y: auto;
  word-wrap: break-word;
}

.image-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: 1rem;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.2s ease-in-out;
  z-index: 2;
}
.image-actions .btn {
  padding: 5px 10px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 4px;
  color: var(--neutral-foreground-rest);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  backdrop-filter: blur(10px);
}
.action-btn:hover {
  background: rgb(255, 255, 255);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.action-btn:active {
  transform: translateY(0);
}

.icon {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--neutral-stroke-divider-rest);
  border-top: 3px solid var(--accent-fill-rest);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-text {
  color: var(--neutral-foreground-hint);
  font-size: 0.875rem;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
}

.error-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.error-text {
  color: var(--error-fill-rest);
  font-size: 0.875rem;
}

@media (max-width: 768px) {
  .image-prompt {
    opacity: 0.9;
    transform: translateY(0);
    position: static;
    background: var(--neutral-layer-2);
    color: var(--neutral-foreground-rest);
    border-bottom: 1px solid var(--neutral-stroke-divider-rest);
    backdrop-filter: none;
    max-height: none;
  }
  .image-actions {
    opacity: 1;
    transform: translateY(0);
    position: static;
    background: var(--neutral-layer-2);
    border-top: 1px solid var(--neutral-stroke-divider-rest);
    justify-content: center;
  }
  .action-btn {
    background: var(--neutral-fill-rest);
    color: var(--neutral-foreground-rest);
  }
  .action-btn:hover {
    background: var(--neutral-fill-hover);
  }
}`;
const shadowOptions = { "mode": "open" };
let GenImage = class GenImage extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.error = '';
        this.imageFormat = 'png'; // Default format
        this.slotContent = '';
        this.isCopied = false;
    }
    async connectedCallback() {
        if (!this.tmp) {
            await this.getFile();
        }
        super.connectedCallback();
        if (this.tmp) {
            this.extractSlottedContent();
        }
    }
    async getFile() {
        this.image = (await this.apiService.back.get('file.get', { routeParams: { id: String(this.fileId) } })).data;
        console.log(this.image);
    }
    handleDownload() {
        if (!this.image)
            return;
        try {
            const link = document.createElement('a');
            link.href = download_helper_1.DownloadHelper.getFilePath(this.image);
            link.download = `generated-image-${this.image.id}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (e) {
            console.error('Error downloading image:', e);
        }
    }
    handleCopyToClipboard() {
        if (!this.image)
            return;
        try {
            // Convert data URL to blob and copy to clipboard
            fetch(download_helper_1.DownloadHelper.getFilePath(this.image))
                .then(res => res.blob())
                .then(blob => {
                const item = new ClipboardItem({ [blob.type]: blob });
                return navigator.clipboard.write([item]);
            })
                .then(() => {
                // Could show a toast notification here
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                }, 2000);
            })
                .catch(err => {
                console.error('Error copying image to clipboard:', err);
            });
        }
        catch (e) {
            console.error('Error copying image:', e);
        }
    }
    extractSlottedContent() {
        // Get all the text content from inside the component tags
        const fullTextContent = this.textContent || this.innerText || '';
        // Store the complete inner text (BASE64) content
        this.slotContent = fullTextContent.trim();
    }
    getFilePath() {
        return download_helper_1.DownloadHelper.getFilePath(this.image);
    }
};
exports.GenImage = GenImage;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GenImage.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GenImage.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _a : Object)
], GenImage.prototype, "image", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], GenImage.prototype, "imageFormat", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], GenImage.prototype, "fileId", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], GenImage.prototype, "tmp", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GenImage.prototype, "slotContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GenImage.prototype, "isCopied", void 0);
exports.GenImage = GenImage = __decorate([
    (0, client_1.RWSView)('gen-image', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], GenImage);
GenImage.defineComponent();
